module.exports = __webpack_public_path__ + "static/media/dogBackBgDestktop.09e794c9.webp";